import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '../scss/style.scss';

document.addEventListener("DOMContentLoaded", function () {

  // Navigation: Burger-Menü
  const menuButton = document.querySelector('#burger');
  const nav = document.getElementById('main-nav');
  const main = document.querySelector('main');
  const header = document.querySelector('header');
  const footer = document.querySelector('footer');

  if (menuButton) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') === 'true';
      const isOpening = !expanded;

      menuButton.setAttribute('aria-expanded', String(isOpening));
      nav.classList.toggle('open');
      document.body.classList.toggle('inactive');

      [main, header, footer].forEach(el => {
        if (isOpening) {
          if (!nav.contains(el)) {
            el.setAttribute('inert', '');
            el.setAttribute('aria-hidden', 'true');
          }
        } else {
          el.removeAttribute('inert');
          el.removeAttribute('aria-hidden');
        }
      });
    });

    window.addEventListener('resize', () => {
      menuButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('inactive');
    });
  }

  // Mobiles Submenü via Klick
  document.querySelectorAll('.nav-item.has-submenu > a').forEach(link => {
    link.addEventListener('click', function (e) {
      const isMobile = window.innerWidth <= 920;
      const parent = this.parentElement;

      if (isMobile) {
        const alreadyOpen = parent.classList.contains('open');
        // alle schließen
        document.querySelectorAll('.nav-item.has-submenu').forEach(item =>
          item.classList.remove('open')
        );

        if (!alreadyOpen) {
          e.preventDefault(); // Untermenü öffnen statt Link folgen
          parent.classList.add('open');
        }
      }
    });
  });

  // Formular Anmeldung Veranstaltung
  const checkbox = document.getElementById("Form_AnmeldeFormular_Datenschutz");
  const description = document.querySelector("#Form_AnmeldeFormular_Datenschutz_Holder .description");

  document.querySelectorAll('p').forEach(p => {
    if (p.textContent.trim().endsWith(':')) {
      p.classList.add('ends-with-colon');
    }
  });

  if (description) {
    description.addEventListener("click", function () {
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
      }
    });
  }

  // Swiper Slider
  const swiperEl = document.querySelector('.header-slider');
  if (swiperEl) {
    new Swiper('.header-slider', {
      modules: [Autoplay, Navigation, Pagination],
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 8000,
        disableOnInteraction: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }
});